export default __webpack_public_path__ + "a7887cf.png";